var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImgIcon = function SvgImgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "img_icon_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 324.6 426.6"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".img_icon_svg__st0{fill:#172b4d}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#172B4D",
    d: "M100.1 195.9c-15.4 0-28 12.5-28 27.9s12.5 28 27.9 28 28-12.5 28-27.9c.1-15.5-12.4-28-27.9-28",
    className: "img_icon_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#172B4D",
    d: "M324.6 247.9v-137c.1-2.2-.8-4.4-2.4-5.9-34.5-34.3-68.9-68.6-103.4-103-1.2-1.3-3-2.1-4.8-2-55.7.1-111.4.1-167.1.1-3.1 0-6.1.3-9.2.8C28 2.4 19.1 7.2 12.5 14.4 3.9 23.5.1 34.4.1 46.9c.1 54.4.1 108.8.1 163.2v153.5c-.2 5.7-.3 11.3 0 17 .2 4.8.9 9.6 2.1 14.2 5.6 18.5 23.4 31.7 44.3 31.7 77.2-.1 154.3-.2 231.5-.1 3 0 6-.2 8.9-.8 15.1-2.8 26-11.2 33-24.8 3.6-7 4.6-14.5 4.6-22.3-.1-43.4-.1-87 0-130.6M27.8 47.6c0-6.4 1.8-12 7-16 3.8-3 8.3-3.7 12.9-3.7l140.7-.2c4.9 0 9.8.1 14.8-.1 2.5-.1 3.1.8 3.1 3.1-.1 18.1 0 36.2 0 54.3 0 7.7 1.6 14.9 6.4 21.1 6.8 8.7 15.8 12.6 26.7 12.6 17.7-.1 35.5-.1 53.2-.2 3.3 0 3.3 0 3.3 3.2v130h.7v87.6l-61.3-76.7-77.2 77.4-38.7-38.7-77.3 77.3H27.8v-331",
    className: "img_icon_svg__st0"
  })));
};
export default SvgImgIcon;